import {dateToString, stringUStoISO} from "../../../date-converter";

export default {
    name: 'OFFERING SUMMARY',
    rows: {
        'price': {
            name: 'Price',
            unit: '$',
            type: 'number',
            editable: false,
            industrySpecific:false,
            getComputedValue(tables) {
                const leaseType = tables['lease-summary'].rows['lease-type'].value;
                const isVacantLeaseType = leaseType === 'Vacant';
                if (isVacantLeaseType) {
                    const grossLeasableArea = tables['offering-summary'].rows['gross-leasable-area'].value;
                    const pricePsf = tables['offering-summary'].rows['price-psf'].value;
                    const value = Math.ceil((grossLeasableArea * pricePsf / 5000)) * 5000;
                    return {internalValue: value, displayValue: '$' + (value ? value.toLocaleString() : 0)};
                }
                const capRate = tables['offering-summary'].rows['cap-rate'].value;
                const netOperatingIncome = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
                const value = capRate ? Math.ceil((netOperatingIncome / (capRate / 100) / 5000)) * 5000 : null;
                return {internalValue: value, displayValue: '$' + (value ? value.toLocaleString() : 0)};
            }
        },
        'cap-rate': {
            name: 'Cap Rate',
            unit: '%',
            type: 'number',
            editable: true,
            hidden: false,
            withDecimals: true,
            industrySpecific:false,
            value: '',
        },
        'price-psf': {
            name: 'Price PSF',
            unit: '$',
            type: 'number',
            hidden: false,
            editable: true,
            industrySpecific:false,
            value: '',
        },
        'net-operating-income': {
            name: 'Net Operating Income (NOI)',
            unit: '$',
            type: 'number',
            editable: false,
            hidden: false,
            tooltip: '= INDEX(annual_rent, MATCH(commencement, analysis_date))',
            industrySpecific:false,
            getComputedValue(tables) {
                const annualizedOperatingDataRows = tables['annualized-operating-data'].rows;
                const analysis = tables['general-information'].rows['analysis-date'].value;
                const analysisDate = analysis ? stringUStoISO(analysis) : '';
                const isSaleLeaseBack = tables['general-information'].rows['sale-lease-back'].value;
                if (!Object.keys(annualizedOperatingDataRows).length || !analysisDate)
                    return {internalValue: null, displayValue: ''};

                const commencementColumnIndex = 1;
                const annualRentColumnIndex = 2;
                let annualRent;

                // Get all commencement dates from table and sort them
                const commencementDates = Object.keys(annualizedOperatingDataRows)
                    .filter(rowIndex => annualizedOperatingDataRows[rowIndex].valueCells[commencementColumnIndex].value)
                    .map((rowIndex) => {
                        const commencementDate = annualizedOperatingDataRows[rowIndex].valueCells[commencementColumnIndex].value;
                        return commencementDate ? stringUStoISO(commencementDate) : '';
                    })
                    .sort();
                
                // Find the last commencement date smaller than or equal to the Analysis Date.
                let foundRowIndex;
                for (let i = 0; i < commencementDates.length; i++) {
                    if (commencementDates && commencementDates[i] && commencementDates[i] <= analysisDate) {
                        foundRowIndex = i;
                    }
                }
                if (isSaleLeaseBack){
                    let saleLeaseCommencementDate = new Date(commencementDates[0]);
                    saleLeaseCommencementDate.setMonth(saleLeaseCommencementDate.getMonth()-6);
                    saleLeaseCommencementDate = dateToString(saleLeaseCommencementDate);
                    if (isSaleLeaseBack == "Yes" && (analysisDate != undefined && analysisDate != null && analysisDate != "") 
                    || saleLeaseCommencementDate === analysisDate) {
                        foundRowIndex = 0;
                    }
                }
                if (foundRowIndex === undefined)
                    return {internalValue: null, displayValue: ''};

                annualRent = tables['annualized-operating-data'].rows[foundRowIndex].valueCells[annualRentColumnIndex].getComputedValue(tables, foundRowIndex).internalValue;
                let addition=0;
                tables['annualized-operating-data'].footerRow.forEach((e,index)=>{
                    if(index>0 && e.valueCells[2].value){
                        addition = addition + parseInt(e.valueCells[2].value);
                    }
                });
                const value = addition ? annualRent + parseInt(addition): annualRent;
                const displayValue = value && !isNaN(value) ? `$${value.toLocaleString()}` : '-';
                return {internalValue: value, displayValue};
            }
        },
        'empty': {
            name: '',
            type: '',
            editable: false,
            hidden: true,
            industrySpecific:false,
            getComputedValue() {
                return {internalValue: 0, displayValue: ''};
            },
        },
        'year-built': {
            name: 'Year Built',
            type: 'number',
            editable: true,
            industrySpecific:false,
            value: '',
        },
        'gross-leasable-area': {
            name: 'Gross Leasable Area (GLA)',
            unit: 'SF',
            type: 'number',
            editable: true,
            industrySpecific:false,
            value: '',
        },
        'lot-size': {
            name: 'Lot Size',
            unit: 'Acres',
            type: 'number',
            editable: true,
            industrySpecific:false,
            value: '',
        },
        'clear-height': {
            name: 'Clear Height',
            unit: 'Ft',
            type: 'number',
            editable: true,
            industrySpecific:true,
            value: '',
        },
        'doors': {
            name: 'Doors',
            editable: true,
            industrySpecific:true,
            value: '',
        },
        'office-to-warehouse': {
            name: 'Office to Warehouse',
            editable: true,
            industrySpecific:true,
            value: '',
        },
    }
};